var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionTargetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 6.66602V4.16602L15.8346 1.66602L16.6679 3.33268L18.3346 4.16602L15.8346 6.66602H13.3346ZM13.3346 6.66602L10.0013 9.9993M18.3346 9.99935C18.3346 14.6017 14.6037 18.3327 10.0013 18.3327C5.39893 18.3327 1.66797 14.6017 1.66797 9.99935C1.66797 5.39698 5.39893 1.66602 10.0013 1.66602M14.168 9.99935C14.168 12.3005 12.3025 14.166 10.0013 14.166C7.70012 14.166 5.83464 12.3005 5.83464 9.99935C5.83464 7.69816 7.70012 5.83268 10.0013 5.83268",
    stroke: "#079455",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionTargetIcon);
export default __webpack_public_path__ + "static/media/actionTargetIcon.167475ecbd620d0a777bda7df030bf7e.svg";
export { ForwardRef as ReactComponent };